import {
  addConstructionQuickView,
  deleteQuickView,
  fetchConstructionData,
  fetchConstructionQuickViews,
  updateConstructionQuickView,
} from "@sdge-store/construction/construction.async";
import { Constants } from "@sdge-store/construction/constants/construction.constants";
import { selectConstruction } from "@sdge-store/construction/construction.selector";
import {
  handleColumnChoosen,
  handleInputText,
  handlePrivacy,
  handleQuickViewId,
  handleQuickViewsModal,
  handleQuickViewsParams,
  handleSearch,
} from "@sdge-store/construction/construction.slice";
import { generateAddQuickView } from "@sdge-utils/helpers/filterHelpers/filterHelpers";
import {
  assignFrozenColumns,
  assignHiddenCols,
  assignSelect,
} from "@sdge-utils/helpers/quickViewsHelpers/quickViewsHelpers";
import { generateSortingString } from "@sdge-utils/helpers/sortHelpers/sortHelpers";
import React, { FC, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { AddViewMenu, QuickViews } from "./components";

const ConstructionQuickViewOptions: FC<any> = ({ columnApi }) => {
  const {
    columnOrder,
    filteringRules,
    hiddenColumns,
    sort,
    quickViews,
    isQuickVeiwsModalOpen,
    frozenColumns,
    initialColumnDefs,
    initialColumnsOrder,
    currentFilter,
    selectedQuickVewName,
    selectedQuickViewPrivacy,
    selectedQuickViewId,
  } = useAppSelector(selectConstruction);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (quickViews.length === 0) {
      dispatch(fetchConstructionQuickViews());
    }
  }, [dispatch, quickViews.length]);

  const AddMenuViewsWithProps = () => (
    <AddViewMenu
      quickViews={quickViews}
      columnsOrder={columnOrder}
      filters={filteringRules}
      hiddenColumns={hiddenColumns}
      frozenColumns={frozenColumns}
      orders={sort}
      setClose={handleQuickViewsModal}
      addColumnAction={addConstructionQuickView}
    />
  );

  const fetchView = (
    sort: any[],
    filter: any[],
    id: string,
    quickViews: any[],
    columnDefs: any[],
    hiddenColumns: string[],
    frozenColumns: string[],
    columnsOrder: string[],
    selectedName: string
  ) => {
    dispatch(handleColumnChoosen(assignSelect(quickViews, id)));
    const sortingRules = generateSortingString(sort);
    dispatch(fetchConstructionData([0, sortingRules, filter, true]));
    const hiddenColsFilter = assignHiddenCols(columnDefs, hiddenColumns);
    const pinnedColsFilter = assignFrozenColumns(
      hiddenColsFilter,
      frozenColumns
    );
    const firstTwoElements = pinnedColsFilter.slice(0, 2);
    const newColumnsOrder = pinnedColsFilter.slice(2).sort((a, b) => {
      return columnsOrder.indexOf(a.field) - columnsOrder.indexOf(b.field);
    });

    const newColumns = [...firstTwoElements, ...newColumnsOrder];
    const newColumnParams = {
      columnDefs: newColumns,
      hiddenColumns: hiddenColumns,
      frozenColumns: frozenColumns,
      columnOrder: columnsOrder,
      sort: sort,
      filter: filter,
      filteringRules: filter,
      selectedName: selectedName,
    };
    dispatch(handleQuickViewsParams(newColumnParams));
    dispatch(handleSearch(""));
    dispatch(handleInputText(""));
    columnApi.moveColumns(columnsOrder, 2);
  };

  const resetViews = (quickViews: any[]) => {
    const newQuickVews = quickViews.map((item) => {
      return { ...item, selected: false };
    });
    const resetedParams = {
      columnDefs: initialColumnDefs,
      hiddenColumns: [],
      frozenColumns: [],
      columnOrder: initialColumnsOrder,
      sort: [],
      filter: [],
      filteringRules: [],
      selectedName: "",
    };
    dispatch(handleColumnChoosen(newQuickVews));
    dispatch(fetchConstructionData([0, "", [], true]));
    dispatch(handleQuickViewsParams(resetedParams));
    dispatch(handleSearch(""));
    dispatch(handleInputText(""));
    columnApi.moveColumns(initialColumnsOrder, 2);
  };

  const handleUpdate = (selectedname: string) => {
    dispatch(
      updateConstructionQuickView(
        generateAddQuickView(
          columnOrder,
          currentFilter,
          hiddenColumns,
          frozenColumns,
          selectedname,
          sort,
          selectedQuickViewPrivacy,
          selectedQuickViewId
        )
      )
    );
  };

  const handleChange = (e: any) => {
    dispatch(handlePrivacy(e.target.checked));
  };

  const handleSetPrivacy = (privacy: boolean) => {
    dispatch(handlePrivacy(privacy));
  };

  const handleSetId = (id: string) => {
    dispatch(handleQuickViewId(id));
  };

  return (
    <QuickViews
      selectedName={selectedQuickVewName}
      resetViews={resetViews}
      component={AddMenuViewsWithProps}
      setOpen={handleQuickViewsModal}
      open={isQuickVeiwsModalOpen}
      quickViews={quickViews}
      columnDefs={Constants.columnDefs}
      fetchView={fetchView}
      deleteView={deleteQuickView}
      updateView={handleUpdate}
      handleChange={handleChange}
      handleSetPrivacy={handleSetPrivacy}
      handleSetId={handleSetId}
    />
  );
};

export default ConstructionQuickViewOptions;
